import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopandharpurcab() {



const cardData = {
  keyword: " Mumbai to Pandharpur Cab",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Pandharpur cab services, ensuring a smooth and hassle-free journey for pilgrims, family trips, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai to Pandharpur convenient and stress-free. The journey covers approximately 420–440 km via the Mumbai–Solapur Highway, typically taking 8–9 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Pandharpur cab travel.",

topPlaces: [
  {
    title: "Vithoba Temple",
    description: "Vithoba Temple is the main pilgrimage site in Pandharpur, dedicated to Lord Vitthal. Travelers from Mumbai can reach the temple comfortably by cab, participate in rituals, and experience the spiritual atmosphere. The temple attracts thousands of devotees, especially during the Ashadi Ekadashi festival."
  },
  {
    title: "Rakhumai Temple",
    description: "Rakhumai Temple, adjacent to Vithoba Temple, is dedicated to Goddess Rakhumai. Visitors traveling by cab from Mumbai can explore the temple, witness traditional rituals, and experience the cultural heritage of Pandharpur."
  },
  {
    title: "Chandrabhaga River",
    description: "Chandrabhaga River flows through Pandharpur and is considered sacred. Travelers from Mumbai can visit the river banks by cab for spiritual rituals, holy dips, and peaceful sightseeing. The serene surroundings make it an ideal spot for relaxation and reflection."
  },
  {
    title: "Sant Namdev Sansthan",
    description: "Sant Namdev Sansthan is a religious site honoring the saint-poet Namdev. Visitors from Mumbai can reach this temple easily by cab, explore its spiritual significance, and learn about the teachings and history of the saint."
  },
  {
    title: "Mahalaxmi Temple",
    description: "Mahalaxmi Temple in Pandharpur is dedicated to Goddess Mahalaxmi. Travelers arriving from Mumbai by cab can visit the temple to seek blessings, admire its architecture, and participate in local rituals."
  },
  {
    title: "Pandharpur Market",
    description: "Pandharpur Market is a bustling local market offering traditional items, religious souvenirs, and local handicrafts. Travelers from Mumbai can explore the market by cab, shop for gifts, and experience the local culture."
  },
  {
    title: "Ashadi Ekadashi Celebrations",
    description: "Ashadi Ekadashi is a major festival in Pandharpur attracting thousands of devotees. Visitors from Mumbai can travel by cab to witness processions, cultural events, and religious ceremonies, experiencing the vibrant atmosphere of this significant occasion."
  },
  {
    title: "Sant Tukaram Samadhi",
    description: "Sant Tukaram Samadhi is the memorial of the revered saint Tukaram. Travelers from Mumbai can visit the site by cab, pay respects, and learn about the spiritual and historical significance of Sant Tukaram’s teachings."
  },
  {
    title: "Pandharpur Ghats",
    description: "Pandharpur Ghats along the Chandrabhaga River are popular for devotional activities and ritual bathing. Visitors from Mumbai can reach the ghats comfortably by cab, enjoy the peaceful riverside environment, and participate in traditional practices."
  },
  {
    title: "Vitthal-Rukmini Festivals",
    description: "Vitthal-Rukmini festivals are celebrated with great devotion in Pandharpur. Travelers from Mumbai using cab services can witness colorful processions, music, and cultural performances, gaining an immersive experience of local traditions."
  }
],



services: [
{
name: "Mumbai to Pandharpur Cab Service",
description: "Mumbai to Pandharpur cab service offers a comfortable and reliable travel option for devotees and travelers visiting the holy town of Pandharpur. Known for the famous Vitthal-Rukmini Temple, this route is highly popular among pilgrims, especially during Ashadhi and Kartiki Yatra. The journey from Mumbai to Pandharpur is smooth with well-connected highways, making it ideal for road travel. Professional drivers with experience in long-distance and religious routes ensure a safe and peaceful journey. Customers can choose from sedan, SUV, and premium vehicles depending on their comfort and group size. Doorstep pickup from Mumbai and direct drop at Pandharpur temple or hotels ensures complete convenience. With transparent pricing, flexible travel schedules, and 24x7 availability, this cab service ensures a hassle-free and spiritually fulfilling journey."
},
{
name: "Mumbai to Pandharpur Taxi",
description: "Mumbai to Pandharpur taxi service provides dependable and comfortable transportation for long-distance travel. This service is ideal for devotees and families who prefer a private journey with flexible timing. Vehicles are well-maintained with clean interiors and comfortable seating for long trips. Drivers are experienced in highway routes and ensure safe driving throughout the journey. Multiple vehicle options including sedan and SUV are available. Flexible pickup locations across Mumbai add convenience. It ensures a smooth and comfortable ride."
},
{
name: "One Way Cab Mumbai to Pandharpur",
description: "One way cab Mumbai to Pandharpur is a cost-effective travel solution for passengers who need a single-side drop without return charges. This service is ideal for pilgrims planning extended stays or onward journeys. Customers benefit from competitive pricing and flexible pickup timing. Professional drivers ensure safe and timely travel across long-distance routes. Multiple vehicle options are available based on budget and comfort. Online booking with instant confirmation makes the process easy. It is a practical and affordable travel option."
},
{
name: "Mumbai to Pandharpur Cab Booking",
description: "Mumbai to Pandharpur cab booking allows customers to reserve their ride quickly with instant confirmation and flexible scheduling. Travelers can select vehicle type, pickup time, and drop location according to their needs. Transparent pricing ensures no hidden charges during the journey. Online booking platforms provide secure payment options and real-time availability. Dedicated support is available for assistance. This service ensures a smooth and organized travel experience. It is the easiest way to plan your pilgrimage trip."
},
{
name: "Mumbai to Pandharpur Taxi Fare",
description: "Mumbai to Pandharpur taxi fare is designed to be transparent and budget-friendly, helping travelers plan their trip efficiently. Pricing depends on vehicle type, travel distance, and trip duration. Customers receive a clear breakdown of charges including tolls and driver allowance where applicable. Affordable options are available for sedan and SUV categories. No hidden charges ensure trust and reliability. Flexible pricing suits different budgets. It offers great value for long-distance travel."
},
{
name: "Cheap Cab Mumbai to Pandharpur",
description: "Cheap cab Mumbai to Pandharpur offers economical travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers and pilgrims looking for reliable transportation. Sedan vehicles provide affordable pricing for long-distance journeys. Transparent billing ensures no hidden charges. Professional drivers ensure safe and smooth travel. Flexible booking options make planning easy. It is a perfect choice for budget-friendly travel."
},
{
name: "Mumbai to Pandharpur Outstation Cab",
description: "Mumbai to Pandharpur outstation cab service provides reliable intercity travel with comfort and safety. This service is suitable for pilgrims, families, and group travelers. Vehicles are well-maintained for long-distance highway travel. Flexible options include one way and round trip packages. Professional drivers ensure safe navigation and timely arrival. Pickup from multiple locations across Mumbai adds convenience. It ensures a hassle-free journey experience."
},
{
name: "Mumbai to Pandharpur SUV Taxi",
description: "Mumbai to Pandharpur SUV taxi is ideal for families and groups who need extra space and comfort during travel. SUVs offer spacious seating and better performance for long-distance journeys. This option is suitable for group travel and trips with luggage. Professional drivers ensure safe and comfortable travel throughout the journey. It provides a premium travel experience. Perfect for group pilgrimage trips. It ensures a smooth and enjoyable ride."
},
{
name: "Mumbai to Pandharpur Sedan Cab",
description: "Mumbai to Pandharpur sedan cab is a popular choice for individuals, couples, and small families seeking a comfortable and economical ride. Sedans offer smooth travel, good mileage, and comfortable seating for long-distance journeys. This service is ideal for budget-friendly travel without compromising convenience. Professional drivers ensure safe and efficient driving. Flexible pickup options enhance convenience. It ensures a pleasant journey experience."
},
{
name: "Mumbai to Pandharpur Car Rental",
description: "Mumbai to Pandharpur car rental service provides flexible travel options with a wide range of vehicles to choose from. Customers can book cars for one way or round trips based on their requirements. This service is ideal for family trips, group travel, and religious tours. Easy booking process and transparent pricing make it convenient. Vehicles are clean, well-maintained, and driven by professional chauffeurs. Flexible pickup options ensure convenience. It ensures a customized travel experience."
},
{
name: "Private Cab Mumbai to Pandharpur",
description: "Private cab Mumbai to Pandharpur offers a personalized travel experience with exclusive vehicle usage for passengers. Travelers can customize routes, stops, and travel schedules according to their preferences. This ensures a relaxed and peaceful journey. Professional drivers provide safe and reliable service with complete privacy. Comfortable seating enhances the experience. It is ideal for private and spiritual travel. It guarantees flexibility and comfort."
},
{
name: "AC Taxi Mumbai to Pandharpur",
description: "AC taxi Mumbai to Pandharpur ensures a comfortable journey in air-conditioned vehicles for long-distance travel. This service provides a cool and pleasant environment throughout the trip. Clean interiors and well-maintained AC systems enhance passenger comfort. Suitable for families, devotees, and business travelers. Flexible booking options make travel planning easy. Professional drivers ensure timely service. It guarantees a relaxing and smooth journey."
}
],

tableData: [
["Mumbai to Pandharpur Cab Service","Mumbai to Pandharpur Taxi"],
["One Way Cab Mumbai to Pandharpur","Mumbai to Pandharpur Cab Booking"],
["Mumbai to Pandharpur Taxi Fare","Cheap Cab Mumbai to Pandharpur"],
["Mumbai to Pandharpur Outstation Cab","Mumbai to Pandharpur SUV Taxi"],
["Mumbai to Pandharpur Sedan Cab","Mumbai to Pandharpur Car Rental"],
["Private Cab Mumbai to Pandharpur","AC Taxi Mumbai to Pandharpur"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Pilgrimage Travel",
    WhyChoosedescription: "Velocity Cabs offers reliable Mumbai to Pandharpur cab service for a smooth and comfortable journey, ideal for devotees traveling for darshan at Vitthal Rukmini Temple."
  },
  {
    WhyChooseheading: "Experienced Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Pandharpur routes, ensuring safe driving, proper navigation, and timely arrival for darshan."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai to Pandharpur cab bookings. Customers receive full fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Pandharpur cab service operates 24/7. Whether you plan early morning departure or overnight pilgrimage travel, we ensure reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and customized Pandharpur darshan packages."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group pilgrimage travel."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many devotees for Mumbai to Pandharpur cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Pandharpur cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai to Pandharpur for one-way and round-trip pilgrimage travel." },
  { question: "How far is Pandharpur from Mumbai?", answer: "The distance between Mumbai and Pandharpur is approximately 380 to 420 km and travel time is around 7 to 9 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Pandharpur cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Mumbai to Pandharpur." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Pandharpur cabs online or through phone booking." },
  { question: "Do you provide darshan packages?", answer: "Yes, we provide customized Pandharpur darshan packages for devotees." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during Ashadhi and Kartiki Ekadashi seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Deshmukh",
    feedback:
      "A smooth and peaceful journey from Mumbai to Pandharpur. The cab was comfortable, and the long travel felt well-managed and stress-free throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "The Mumbai to Pandharpur cab service was very reliable. The vehicle was clean, the ride was steady, and the entire pilgrimage trip felt comfortable and well-organized.",
    rating: 5
  }
];






















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const mumbaiPandharpurCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Pandharpur Cab | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Pandharpur for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Pandharpur Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai to Pandharpur",
        "description": "Private cab from Mumbai to Pandharpur for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai to Pandharpur Cab",
        "description": "Comfortable round-trip cab service from Mumbai to Pandharpur with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};






  return (
    <div>
      <Helmet>
  <title>Mumbai to Pandharpur Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Pandharpur for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiPandharpurCabJSON)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopandharpurcab;